export const LOGOUT = 'AP/App/LOGOUT'
export const LOGOUT_SUCCESS = 'AP/App/LOGOUT_SUCCESS'
export const LOGOUT_ERROR = 'AP/App/LOGOUT_ERROR'
